import ManageGroup from "./ManageGroup"
import ManageUser from "./ManageUser"
import ManageRole from "./ManageRole"
import AssignGroups from "./AssignGroups"
import AssignAdmin from "./AssignAdmin"
import AssignRoles from "./AssignRoles"
import AssignAuthority from "./AssignAuthority"

const DashRoute = [
    {
        path: '/admin/manage-user',
        parentRoute: '/admin',
        component: ManageUser,
    },
    {
        path: '/admin/manage-group',
        parentRoute: '/admin',
        component: ManageGroup,
    },
    {
        path: '/admin/manage-role',
        parentRoute: '/admin',
        component: ManageRole,
    },
    {
        path: '/admin/assign-admin',
        parentRoute: '/admin',
        component: AssignAdmin,
    },
    {
        path: '/admin/assign-groups',
        parentRoute: '/admin',
        component: AssignGroups,
    },
    {
        path: '/admin/assign-roles',
        parentRoute: '/admin',
        component: AssignRoles,
    },
    {
        path: '/admin/assign-authority',
        parentRoute: '/admin',
        component: AssignAuthority,
    },
]

export default DashRoute;
